export default "__VITE_ASSET__DsGOpZaH__"